/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "./ToggleSwitch.css";
import PropTypes from "prop-types";

function ToggleSwitch(props) {
  const { checked, onChange = () => {}, disabled = false, disabledMessage = "" } = props;

  return (
    <div className={`switch-container${disabled ? " disabled" : ""}`} title={disabled ? disabledMessage : ""}>
      <label className={`switch${disabled ? " disabled" : ""}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={disabled ? () => {} : onChange}
          disabled={disabled}
        />
        <span className="slider round"></span>
      </label>
      {disabled && disabledMessage && (
        <div className="switch-disabled-message">{disabledMessage}</div>
      )}
    </div>
  );
}

ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
};

export default ToggleSwitch;
